// script.js
// Main accordion toggle
document.querySelectorAll(".accordion-title").forEach((item) => {
  item.addEventListener("click", () => {
    const content = item.nextElementSibling;
    const button = item.querySelector(".toggle-button");

    // Close all other main accordion sections
    document.querySelectorAll(".accordion-content").forEach((accContent) => {
      if (accContent !== content) {
        accContent.style.display = "none";
        accContent.previousElementSibling.querySelector(
          ".toggle-button"
        ).textContent = "+";

        // Also close all sub-accordion items within the closed main accordion
        accContent
          .querySelectorAll(".sub-accordion-content")
          .forEach((subContent) => {
            subContent.style.display = "none";
            subContent.previousElementSibling.querySelector(
              ".sub-toggle-button"
            ).textContent = "+";
          });
      }
    });

    // Toggle the current accordion section
    content.style.display =
      content.style.display === "block" ? "none" : "block";
    button.textContent = button.textContent === "+" ? "-" : "+";
  });
});

// Sub-accordion toggle
document.querySelectorAll(".sub-accordion-title").forEach((item) => {
  item.addEventListener("click", () => {
    const content = item.nextElementSibling;
    const button = item.querySelector(".sub-toggle-button");

    // Close other sub-accordions within the same main accordion
    const parentAccordion = item.closest(".accordion-content");
    parentAccordion
      .querySelectorAll(".sub-accordion-content")
      .forEach((subContent) => {
        if (subContent !== content) {
          subContent.style.display = "none";
          subContent.previousElementSibling.querySelector(
            ".sub-toggle-button"
          ).textContent = "+";
        }
      });

    // Close all main accordion sections and sub-accordions in other main accordions
    document.querySelectorAll(".accordion-content").forEach((accContent) => {
      if (accContent !== parentAccordion) {
        accContent.style.display = "none";
        accContent.previousElementSibling.querySelector(
          ".toggle-button"
        ).textContent = "+";

        accContent
          .querySelectorAll(".sub-accordion-content")
          .forEach((subContent) => {
            subContent.style.display = "none";
            subContent.previousElementSibling.querySelector(
              ".sub-toggle-button"
            ).textContent = "+";
          });
      }
    });

    // Toggle the current sub-accordion section
    content.style.display =
      content.style.display === "block" ? "none" : "block";
    button.textContent = button.textContent === "+" ? "-" : "+";
  });
});
